import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import Select from 'react-select';
import DirectoryService from 'components/app/directory/DirectoryService';
import axios from 'axios';
import { useState, useEffect } from 'react';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import Flex from 'components/common/Flex';

const UploadFileModal = ({ showUploadFileModal, setShowUploadFileModal, task }) => {
  const [sharedWith, setSharedWith] = useState([]);
  const [users, setUsers] = useState([]);
  const [isOnboarding, setIsOnboarding] = useState(true);
  const [validated, setValidated] = useState(false);

  useEffect(async () => {
    try {
      const usersByAccount = await DirectoryService.retrieveUsersByAccount();
      const mappedUsers = usersByAccount.map(u => ({
        value: u.identifier,
        label: u.firstName + ' ' + u.lastName
      }));
      setUsers(mappedUsers);
    } catch (error) {
      console.error('Error:', error);
    }
    }, []);
    
  const handleSubmit = event => {
    event.preventDefault();
    const data = JSON.stringify({
      document: null,
      sharedWith: sharedWith,
      isOnboarding: isOnboarding,
      todoIdentifier: task.identifier
    });
    console.log('Data:', data);
    const { identifier } = DirectoryService.retrieveLoggedProfile();
    acceptedFiles.map(file => {
      const sharedFile = file;
      const url = '/api/document/upload/profile/' + identifier;
      const formData = new FormData();
      formData.append('file', sharedFile);
      formData.append('fileName', sharedFile.name);
      formData.append('documentPayload', data);
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };
      axios.post(url, formData, config).then(response => {
        console.log(response.data);
        setShowUploadFileModal(false);
        setValidated(false);
      }).catch(error => {
        console.error('Error uploading file:', error);
        setValidated(true);
      });
    });     
  };   
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    maxSize: 5 * 1024 * 1024,
    maxFiles: 5,
    multiple: true
  });
    const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  return (
    <>
      <Modal
        show={showUploadFileModal}
        onHide={() => setShowUploadFileModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="mb-3"
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
          >
            <Form.Group className="mb-3" controlId="sharedWith">
              <Form.Label className="fs-0">Shared with</Form.Label>
              <Select
                closeMenuOnSelect={false}
                name="sharedWith"
                key="sharedWith"
                options={users}
                placeholder="Share document with..."
                isMulti={true}
                classNamePrefix="react-select"
                value={sharedWith}
                onChange={value => setSharedWith(value)}
              />
            </Form.Group>
            <div {...getRootProps({ className: 'dropzone-area py-6' })}>
              <input {...getInputProps({ multiple: true })} name="file" />
              <Flex justifyContent="center">
                <img src={cloudUpload} alt="" width={25} className="me-2" />
                <p className="fs-0 mb-0 text-700">Drop your file here</p>
              </Flex>
            </div>
            <div className="mt-3">
              {acceptedFiles.length > 0 && (
                <>
                  <h6>File</h6>
                  <ul>{files}</ul>
                </>
              )}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            Upload
          </Button>  
          <Button
            variant="secondary"
            onClick={() => setShowUploadFileModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default UploadFileModal;